<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-phone"></i> Enter Phone Number</h5>
</div>
<div class="modal-body">
  <div class="row mb-3">
    <div class="offset-2 col-sm-8">Your account info is incomplete. Please enter your phone number(s) to proceed.</div>
  </div>
  <form [formGroup]="form">
    <div class="row">
      <div class="offset-2 col-sm-8">
        <div class="phone-number-wrapper" formGroupName="account">
          <ng-select
            [items]="dialCodes"
            [selectOnTab]="true"
            [clearable]="false"
            appendTo="body"
            bindLabel="codeDisplay"
            bindValue="code"
            formControlName="code"
            placeholder="Code"
            class="phone-code"
            [required]="true"
            [loading]="isLoading"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center">
                <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc"></span>
                <span>
                  {{ item.codeDisplay }}
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center" style="margin: 0 -15px">
                <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc"></span>
                <span>
                  {{ item.codeDisplay }}
                </span>
              </div>
            </ng-template>
          </ng-select>
          <mat-form-field class="phone-number">
            <input type="text" formControlName="phone" matInput placeholder="Account Phone Number" required />
            <mat-hint *ngIf="accountForm.hasError('phone')" class="text-danger"> Phone Number is invalid. </mat-hint>
            <mat-error *ngIf="accountForm.get('phone').hasError('required')"> Phone Number is required. </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="offset-2 col-sm-8">
        <div class="phone-number-wrapper" formGroupName="user">
          <ng-select
            [items]="dialCodes"
            [selectOnTab]="true"
            [clearable]="false"
            appendTo="body"
            bindLabel="codeDisplay"
            bindValue="code"
            formControlName="code"
            placeholder="Code"
            class="phone-code"
            [required]="true"
            [loading]="isLoading"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center">
                <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc"></span>
                <span>
                  {{ item.codeDisplay }}
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center" style="margin: 0 -15px">
                <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc"></span>
                <span>
                  {{ item.codeDisplay }}
                </span>
              </div>
            </ng-template>
          </ng-select>
          <mat-form-field class="phone-number">
            <input type="text" formControlName="phone" matInput placeholder="Your Phone Number" required />
            <mat-hint *ngIf="userForm.hasError('phone')" class="text-danger"> Phone Number is invalid. </mat-hint>
            <mat-error *ngIf="userForm.get('phone').hasError('required')"> Phone Number is required. </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    (click)="save(form)"
    type="button"
    [disabled]="isValidating"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
</div>
